<app-dialog
  [actionLeadText]="'DIALOG.TAX_YEAR_FILTER.UPDATE_IN_SETTINGS' | translate"
  [htmlActionLead]="true"
  [primaryActionText]="'ACTION.GOT_IT' | translate"
  [secondaryActionText]="'ACTION.UPDATE_FINANCIAL_YEAR' | translate"
  [dialogType]="dialogType"
  [trackingObject]="trackingObject"
  [trackingScreenName]="trackingScreenName"
  [primaryActionTapped]="gotItTrackingAction"
  [secondaryActionTapped]="updateTaxYearTrackingAction"
  dialogE2eId="tax-year-filter"
  (onSecondaryAction)="navigateToTaxYearSettings()"
>
  <div id="tax-year-filter-dialog">
    <h2 class="header-text">
      {{ 'DIALOG.TAX_YEAR_FILTER.LISTS_HAVE_CHANGED' | translate }}
    </h2>

    <p class="body-text">
      {{ 'DIALOG.TAX_YEAR_FILTER.LISTS_ORGANIZED_BY_TAX_YEAR' | translate }}
    </p>
  </div>
</app-dialog>
